import { makeStyles } from '@material-ui/core/styles';
// import {  createStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
    formRoot: {
        '& > *': {
          margin: theme.spacing(1),
          marginLeft: theme.spacing(0),
          marginRight: theme.spacing(0),
        //   width: '100%',
        },
    },
    selectFormControl: {
        margin: theme.spacing(1),
        minWidth: 400,
    },
    radioFormControl: {
        margin: theme.spacing(3),
      },
    formSelectEmpty: {
        marginTop: theme.spacing(2),
    },
    tabRoot: {
        backgroundColor: theme.palette.background.paper,
        // width: '100%',
        // flexGrow: 1,
        padding: 0,
    },
    panelRoot: {
        width: '100%',
      },
    panelHeading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    listRoot: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    listNested: {
        paddingLeft: theme.spacing(4),
        // border: '1px solid red',
    },
    stepperRoot: {
        width: '100%',
    },
    stepperBackButton: {
        marginRight: theme.spacing(1),
    },
    stepperInstructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    agentIdBtn: {
        margin: theme.spacing(1),
    },
    guarantorIdBtn: {
        margin: theme.spacing(1),
    },
}));